<div class="form-slots" [ngStyle]="slotStyles">
  @for (slotId of slots?.slotIds; track slotId) {
    <div [blazeSlotNode]="slots?.slotNodesData?.[slotId]">
      @if (noBindingMessage$ | async; as emptyMessage) {
        <div class="hint-generate">
          <span class="description">{{ emptyMessage }}</span>
        </div>
      }
      <ng-container
        *ngTemplateOutlet="slots?.templates?.[slotId] || null; context: slotElementContext"
      />
    </div>
  }
</div>
